import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Sparkles } from '@/components/icons';

export function CheckoutSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  const checkoutId = searchParams.get('checkout_id');

  // Auto-redirect countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-background [background-image:radial-gradient(var(--border)_1px,transparent_1px)] [background-size:24px_24px]">
      <div className="max-w-md w-full">
        <div className="rounded-xl p-8 text-center bg-card border border-border shadow-xl">
          {/* Success Icon with Animation */}
          <div className="relative inline-flex items-center justify-center mb-6">
            <div className="absolute inset-0 bg-emerald-500/20 rounded-full animate-ping" />
            <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center">
              <CheckCircle2 className="w-10 h-10 text-white" />
            </div>
          </div>

          {/* Sparkles */}
          <div className="flex justify-center gap-2 mb-4">
            <Sparkles className="w-5 h-5 text-amber-500" />
            <Sparkles className="w-5 h-5 text-primary" />
            <Sparkles className="w-5 h-5 text-amber-500" />
          </div>

          <h1 className="text-2xl font-bold mb-3 text-foreground">
            Payment Successful!
          </h1>

          <p className="mb-6 text-muted-foreground">
            Thank you for your purchase. Your account has been upgraded and you now have access to all premium features.
          </p>

          {checkoutId && (
            <p className="text-xs mb-6 font-mono text-muted-foreground">
              Order ID: {checkoutId.substring(0, 8)}...
            </p>
          )}

          {/* Action Button */}
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 px-4 rounded-lg font-semibold text-sm bg-primary text-primary-foreground hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
          >
            Start Creating
            <ArrowRight className="w-4 h-4" />
          </button>

          {/* Auto-redirect notice */}
          <p className="mt-4 text-sm text-muted-foreground">
            Redirecting to dashboard in {countdown} seconds...
          </p>
        </div>

        {/* Additional Info */}
        <div className="mt-6 text-center text-sm text-muted-foreground">
          <p>
            A confirmation email has been sent to your email address.
          </p>
          <p className="mt-2">
            Questions?{' '}
            <a
              href="mailto:support@stacksketch.site"
              className="font-medium text-primary hover:underline"
            >
              Contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default CheckoutSuccess;
